import {
  CircularProgress,
  Box,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  TableContainer,
  Paper,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { newTemplateActions } from '../../../../redux/slices/newTemplateSlice';
import { api } from '../../../../redux/api';

export default function NtwRepTemplateTable(props) {
  const [selected, setSelected] = useState("");
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState();
  const currentScreen = useSelector(state => state.treeData.currentScreen)
  const { account } = useSelector(state => state.queryParams)
  const dispatch = useDispatch();

  const handleListItemClick = (event, index, item) => {
    setSelectedIndex(index)
    // setSelectedItem(item);
    dispatch(newTemplateActions.setSelectedRepTemplate(item))
    if (props.repo_type === 'EDI') dispatch(newTemplateActions.setTemplateName(`edi_${item.title}`))
  };
  useEffect(() => {
    dispatch(api.endpoints.getRepositoryFiles.initiate({
      account: account,
      template_type: currentScreen === "inbound" ? "INBOUND" : "OUTBOUND",
      path: props.path,
      repo_type: props.repo_type,
      release_key: props.release_key,
      title: props.version
    }, { forceRefetch: true })).then(response => {
      if (response.status === 'pending') {
        setIsLoading(true);
      }
      else if (response.data.current_state === 'SUCCESS') {
        setTableData(response.data.data)
        setIsLoading(false);

      }
    })
  }, [])

  function getData() {
    let data = [];
    for (let i = 0; i < tableData.length; i++) {
      data.push(
        <TableRow
          className={`hover-pointer s-table-row ${
            selected === `Template ${i}` ? "s-table-row-selected" : ""
          }`}
          key={i}
          sx={{
            "&:last-child td, &:last-child th": { border: 0 },
            borderBottom:
              i === tableData.length - 1 ? "none" : "1px solid #e0e0e0",
            backgroundColor: selectedIndex === i ? "#cbf0ff" : "transparent",
          }}
          onClick={(event) => handleListItemClick(event, i, tableData[i])}>
          <TableCell
            component="th"
            scope="row"
            style={{ borderRight: "1px solid #e0e0e0" }}>
            {tableData[i].title}
          </TableCell>
          <TableCell>{tableData[i].description}</TableCell>
        </TableRow>
      );
    }
    return data
  }

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100px",
          }}>
          <CircularProgress />
        </Box>
      ) : (
        tableData.length > 0 && (
          <TableContainer component={Paper} sx={{ height: "100%" }}>
            <Table
              sx={{ minWidth: 600 }}
              stickyHeader
              size="small"
              aria-label="a table">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      borderRight: "1px solid #e0e0e0",
                      backgroundColor: "#f1f1f1",
                    }}>
                    Template
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f1f1f1" }}>
                    Description
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{getData()}</TableBody>
            </Table>
          </TableContainer>
        )
      )}
    </>
  );
}
